import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { TimeLineService } from '../../timeline/services/timeline.service';
import { ITimelineComments } from 'rebus-models';

@Pipe({ name: 'getCommentsTimeLine' })
export class GetCommentsTimeLine implements PipeTransform {
  constructor(
    private timeLineService: TimeLineService
  ) { }
  public transform(timeLineId: string, eventId: string): Observable<ITimelineComments[]> {
    return this.timeLineService.getCommentsByTimeLine(timeLineId, eventId);
  }
}
